module.exports = __webpack_public_path__ + "img/tower64_ua.8315055b.webp";